import { createContext, useContext, useMemo, useState } from 'react';

export const INPUT_TYPE_MATERIALS = 'Materials';
export const INPUT_TYPE_FUEL = 'Fuel';

const initialState = {
  type: INPUT_TYPE_MATERIALS,
};

export const InputTypeContext = createContext({
  type: initialState.type,
  setSelectedType: () => {},
});

export const InputTypeContextProvider = ({ children }) => {
  const [type, setSelectedType] = useState(initialState.type);
  const value = useMemo(
    () => ({
      type,
      setSelectedType,
    }),
    [type],
  );

  return (
    <InputTypeContext.Provider value={value}>
      {children}
    </InputTypeContext.Provider>
  );
};

export const useInputTypeContext = () => useContext(InputTypeContext);
